import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, message, Pagination, Alert, Button, Select, DatePicker, } from 'antd';
import ReporteCapacitacionService from '../../../services/api/reporte_capacitaciones';
import helper from '../../../utils/helper';
import { DownloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import apiConfig from '../../../services/api/config';
import ImprimirModal from '../../../components/ImprimirModal/ImprimirModal';

class IndexReporteCapacitaciones extends Component {
  state = {
    cargando: false,
    reportes: [],
    categoria: '',
    modalidad: '',
    tipo_servicio_formato: 'Todos',
    de: moment().format('YYYY-MM-DD'),
    fecha_fin_temp: moment(),
    a: moment().format('YYYY-MM-DD'),
    fecha_inicio_temp: moment(),
    openImprimirModal: false,
    page: {
      number: 1,
      per_page: 15,
      order_column: 'created_at',
      order_type: 'desc',
      from: 0,
      to: 0,
      last_page: 0,
      total: 0,
      buscar_texto: '',
    },
  };

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidMount() {
    this.unlisten = this.props.history.listen(this.handleChangeLocation);
    if (this.props.location && this.props.location.search) {
      const queryString = new URLSearchParams(this.props.location.search);
      if (queryString) {
        const buscar_texto = queryString.get('buscar_texto');
        const configPage = Object.assign({}, this.state.page);
        configPage.buscar_texto = buscar_texto;
        this.setState({
          page: configPage,
        });
      }
    }

    this.cargarReporteCapacitaciones();
  }

 searchTimeout = null;

  handleChangeSearch = (value) => {
    const texto = value.target.value;
  
    // Limpiar timeout anterior si el usuario sigue escribiendo
    clearTimeout(this.searchTimeout);
  
    // Guardar texto temporalmente en el estado (opcional)
    const configPage = { ...this.state.page };
    configPage.buscar_texto = texto;
    this.setState({
      page: configPage,
      buscar_texto: texto
    });
  
    // Esperar 600ms después de dejar de escribir para buscar
    this.searchTimeout = setTimeout(() => {
      this.cargarReporteCapacitaciones();
    }, 300);
  }
  // handleChangeSearch = (value) => {
  //   const configPage = Object.assign({}, this.state.page);
  //   configPage.buscar_texto = value.target.value;
  //   this.setState({
  //     page: configPage,
  //     buscar_texto: value.target.value
  //   }, () => {
  //     this.cargarReporteCapacitaciones();
  //   });
  // }

  handleChangeSearchIcon = () => {
    const configPage = Object.assign({}, this.state.page);
    configPage.buscar_texto = this.state.buscar_texto;
    this.setState({
      page: configPage,
      buscar_texto: this.state.buscar_texto
    }, () => {
      this.cargarReporteCapacitaciones();
    });
  }


  cargarReporteCapacitaciones = (path = undefined) => {
    this.setState({
      cargando: true,
    });

    if (!path || path === undefined) {
      path = `?page=${this.state.page.number}&per_page=${this.state.page.per_page}&order_column=${this.state.page.order_column}&order_type=${this.state.page.order_type}&categoria=${this.state.categoria}&modalidad=${this.state.modalidad}&&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}`;
      if (this.state.page && this.state.page.buscar_texto && this.state.page.buscar_texto !== '') {
        path = `${path}&buscar_texto=${this.state.page.buscar_texto}`;
      }
    }

    ReporteCapacitacionService.getReporteCapacitaciones(
      path,
      (page) => {
        if (page && page.data && page.data.length > 0) {
          const configPage = Object.assign({}, this.state.page);
          configPage.from = page.from;
          configPage.to = page.to;
          configPage.last_page = page.last_page;
          configPage.total = page.total;
          configPage.number = page.current_page;
          configPage.per_page = parseInt(page.per_page);
          configPage.buscar_texto = page.buscar_texto ? page.buscar_texto : '';

          this.setState({
            cargando: false,
            reportes: page.data,
            page: configPage,
          });
        } else {
          this.setState({
            reportes: [],
            cargando: false,
          });
        }
      },
      (error, result) => {
        if (error) {
          message.error(error.message);
          this.setState({
            cargando: false,
          });
        }
      }
    );
  };

  handleChangeLocation = (location, action) => {
    const queryString = new URLSearchParams(location.search);
    const buscar_texto = queryString.get('buscar_texto');

    if (buscar_texto && buscar_texto != null) {
      const page = Object.assign({}, this.state.page);

      page.buscar_texto = buscar_texto;

      this.setState({
        page,
      });

      setTimeout(() => {
        this.cargarReporteCapacitaciones();
      }, 10);
    }
  };

  handleChangePerPage = (current, pageSize) => {
    const page = Object.assign({}, this.state.page);
    page.number = current;
    page.per_page = pageSize;
    let path = `?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&categoria=${this.state.categoria}&modalidad=${this.state.modalidad}&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}`;
    if (this.state.buscar_texto && this.state.buscar_texto !== '') {
      path = `${path}&buscar_texto=${this.state.buscar_texto}`;
    }
    this.props.history.push(path);
    this.cargarReporteCapacitaciones(path);
  };

  showTotal = (total) => {
    return `Total ${total} registros`;
  };

  handleClickExportarXLS = () => {
    const page = Object.assign({}, this.state.page);
    let path = `?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&categoria=${this.state.categoria}&modalidad=${this.state.modalidad}&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}`;
    if (this.state.buscar_texto && this.state.buscar_texto !== '') {
      path = `${path}&buscar_texto=${this.state.buscar_texto}`;
    }
    const token =  localStorage.getItem(apiConfig.constants.ACCESS_TOKEN_KEY) || null;
    const url_exportar = `${apiConfig.constants.URL_API}/api/${apiConfig.constants.API_VERSION}/reporte/capacitaciones/xls${path}&authorization=${token}&empresa_id=${apiConfig.constants.EMPRESA_ID}`;
    window.open(url_exportar);
  };

  handleChangeTipo = (value, opt) => {
    this.setState({
      categoria: value,
      tipo_servicio_formato: opt.label
    }, () => {
      this.cargarReporteCapacitaciones();
    });
  };

  handleChangeTipoModalidad = (value, opt) => {
    this.setState({
      modalidad: value,
    }, () => {
      this.cargarReporteCapacitaciones();
    });
  };

  onChangeInicio = (value) => {
    this.setState({
      de: value.format('YYYY-MM-DD'),
      fecha_inicio_temp: value
    }, () => {
      this.cargarReporteCapacitaciones();
    });
  }

  onChangeFin = (value) => {
    this.setState({
      a: value.format('YYYY-MM-DD'),
      fecha_fin_temp: value
    }, () => {
      this.cargarReporteCapacitaciones();
    });
  }

  handleExportar = (value) => {
    const page = Object.assign({}, this.state.page);
    const empresa_id =apiConfig.constants.EMPRESA_ID;
    const token = null;
    let printPDFUrl = null;

    if (value === '1') {
      printPDFUrl = `${apiConfig.constants.URL_NEGOCIOS}/api/${apiConfig.constants.API_VERSION}/reporte/cobranzas/forma-pago?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&categoria=${this.state.categoria}&modalidad=${this.state.modalidad}&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}&empresa_id=${empresa_id}&authorization=${token}`;
    } else {
      printPDFUrl = `${apiConfig.constants.URL_NEGOCIOS}/api/${apiConfig.constants.API_VERSION}/reporte/cobranzas/tipo-servicios?page=${page.number}&per_page=${page.per_page}&order_column=${page.order_column}&order_type=${page.order_type}&categoria=${this.state.categoria}&modalidad=${this.state.modalidad}&tipo_servicio_formato=${this.state.tipo_servicio_formato}&de=${this.state.de}&a=${this.state.a}&empresa_id=${empresa_id}&authorization=${token}`;
    }
    if (this.state.buscar_texto !== undefined || this.state.buscar_texto !== '') {
      printPDFUrl = `${printPDFUrl}&buscar_texto=${this.state.buscar_texto}`;
    }

    this.setState({
      printPDFUrl,
      openImprimirModal: true
    })
  }

  handleClickCloseImprimirModal = (value) => {
    this.setState({
      openImprimirModal: false
    })
  }


  render() {
    const columns = [
      {
        title: 'SKU producto',
        dataIndex: 'producto_sku',
        key: 'producto_sku',
        responsive: ['lg', 'xl'],
      },
      {
        title: 'Doc. Identidad',
        dataIndex: 'numero_documento',
        key: 'numero_documento',
        responsive: ['lg', 'xl'],
        ellipsis: true,
      },      
      {
        title: 'Nombre',
        dataIndex: 'nombres',
        key: 'nombres',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'Categoría',
        dataIndex: 'categoria',
        key: 'categoria',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'Teléfono',
        dataIndex: 'telefono',
        key: 'telefono',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'Correo',
        dataIndex: 'correo_electronico',
        key: 'correo_electronico',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'Modalidad',
        dataIndex: 'modalidad',
        key: 'modalidad',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'Fecha de Pago',
        dataIndex: 'fecha_pago',
        key: 'fecha_pago',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'Nro Comprobante',
        dataIndex: 'comprobante',
        key: 'comprobante',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
      {
        title: 'Monto',
        dataIndex: 'monto',
        key: 'monto',
        responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      },
    ];

    return (
      <div>
        <div className="page-header">
          <h2 className="page-header">Reporte capacitaciones</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', columnGap: 6 }}>
            <div className="topnav__search">
              <input
                type="text"
                placeholder="Buscar..."
                onChange={this.handleChangeSearch}
                value={ this.state.buscar_texto }
              />
              <i onClick={() => this.handleChangeSearchIcon()} className="bx bx-search" style={{cursor: 'pointer'}}></i>
            </div>
            <div>
              <Select
                value={this.state.categoria}
                onChange={this.handleChangeTipo}
                style={{ width: 150 }}
                options={[
                  {
                    value: '',
                    label: 'Todos',
                  },
                  {
                    value: 'Habil',
                    label: 'Habil',
                  },
                  {
                    value: 'No Habil',
                    label: 'No Habil',
                  },
                  {
                    value: 'Vitalicio',
                    label: 'Vitalicio',
                  },
                  {
                    value: 'Bachiller/Estudiante',
                    label: 'Bachiller/Estudiante',
                  },
                  {
                    value: 'Publico General',
                    label: 'Publico General',
                  },
                  {
                    value: 'Cooporativo',
                    label: 'Cooporativo',
                  },
                ]}
              />
            </div>
            <div>
              <Select
              value={this.state.modalidad}
                onChange={this.handleChangeTipoModalidad}
                style={{ width: 110 }}
                options={[
                  {
                    value: '',
                    label: 'Todos',
                  },
                  {
                    value: 'Virtual',
                    label: 'Virtual',
                  },
                  {
                    value: 'Presencial',
                    label: 'Presencial',
                  },
                  {
                    value: 'Hibrido',
                    label: 'Hibrido',
                  },
                ]}
              />
            </div>
            <div>
            <DatePicker value={this.state.fecha_inicio_temp} format={'DD/MM/YYYY'} onChange={this.onChangeInicio} />
            </div>
            <div>
            <DatePicker value={this.state.fecha_fin_temp} format={'DD/MM/YYYY'} onChange={this.onChangeFin} />
            </div>
            <div>
              <Button onClick={this.handleClickExportarXLS} type="primary" shape="round" icon={<DownloadOutlined />} size={null}>
                Descargar Excel
              </Button>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              {!helper.tienePermiso(this.props.permisos, 'Ver registro pagos pendientes') ? (
                <Alert
                  message="Permiso"
                  description="No tiene permiso para ver lista de pagos pendientes"
                  type="error"
                />):
                <div className="card__body">
                  <Table
                    rowKey={(record) => record.id}
                    columns={columns}
                    dataSource={this.state.reportes}
                    pagination={false}
                    loading={this.state.cargando}
                    size="small"
                  />
                  <div style={{ paddingTop: 12, textAlign: 'right' }}>
                    <Pagination
                      size="small"
                      showTotal={this.showTotal}
                      total={this.state.page.total}
                      current={this.state.page.number}
                      pageSize={this.state.page.per_page}
                      onChange={this.handleChangePerPage}
                      onShowSizeChange={this.handleChangePerPage}
                      pageSizeOptions={[10, 20, 30, 40]}
                      showQuickJumper
                      showSizeChanger
                    />
                  </div>
                </div>
              }              
            </div>
          </div>
        </div>
        {this.state.openImprimirModal ? (
          <ImprimirModal
            visible={this.state.openImprimirModal}
            onCancel={this.handleClickCloseImprimirModal}
            url={this.state.printPDFUrl}
            mime_type="application/pdf"
          />
        ) : (
          ''
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permisos: state && state.user && state.user.permisos.length > 0 ? state.user.permisos : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(IndexReporteCapacitaciones);
